/**
 *
 *
 *
 *
 * 此模块为认证模块帮助方法
*/
import Delivery from '../assets/images/attestation/delivery.png'
import Driver from '../assets/images/attestation/driver.png'
import Enterprise from '../assets/images/attestation/enterprise.png'
import Vehicleowner from '../assets/images/attestation/vehicle-owner.png'

export const identityData = [
  {
    id: 1,
    name: '车主',
    image: Vehicleowner,
    is_active: true,
  },
  {
    id: 2,
    name: '司机',
    image: Driver,
    is_active: false,
  },
  {
    id: 3,
    name: '物流企业',
    image: Delivery,
    is_active: false,
  },
  {
    id: 4,
    name: '工厂/发货个人',
    image: Enterprise,
    is_active: false,
  }
]

/**
 *
 *
 *
 * 后台的错误code
*/
export const errorData = [70408, 70402, 70410, 70409, 70407, 70413, 70414, 70405, 70416]

/**
 *
 * 过滤后台的code值
 * @export
 * @param {*} code
 */
export function filterCodeMessage(code) {
  let value = null
  switch (code) {
    case 70419:
      value = '车主姓名不匹配<br/>请核实车主姓名'
      break;
    case 70418:
      value = '车主手机号不匹配<br/>请填写车主登记手机号'
      break;
    case 70417:
      value = '您已多次认证失败，请上传行驶证认证'
      break;
    case 70402:
      value = '您今天提交次数已达上限，请明天再来'
      break;
    case 70416:
      value = '请更换车牌号或联系客服更改认证'
      break;
    case 70408:
      value = '请上传该车行驶证正面，确保图片清晰'
      break;
    case 70410:
      value = '营业执照识别不成功'
      break;
    case 70409:
      value = '驾驶证识别不成功'
      break;
    case 70407:
      value = '证件与身份证信息不符'
      break;
    case 70412:
      value = '证件已过期'
      break;
    case 70413:
      value = '车牌号不匹配'
      break;
    case 70414:
      value = '请上传用户名一致的行驶证及营业执照<br/>确保图片清晰'
      break;
    case 0:
      value = '恭喜您已获得10票奖励'
      break;
    default:
      break;
  }
  return value
}

export function filterIdentificationImg(id) {
  let src = null
  switch (id) {
    case 1:
      src = Vehicleowner
      break;
    case 2:
      src = Driver
      break;
    case 3:
      src = Enterprise
      break;
    case 4:
      src = Delivery
      break;
    default:
      break;
  }
  return src
}